import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _moment from 'moment';
const moment = (_moment as any).default || _moment;

@Component({
  selector: 'app-select-week-dialog',
  templateUrl: './select-week-dialog.component.html',
  styleUrls: ['./select-week-dialog.component.scss'],
  standalone: false
})
export class SelectWeekDialogComponent implements OnInit, AfterViewInit {
  weekDefs: any[] = [];
  currentWeekNo!: number;
  currentYear!: number;

  years: any[] = [];
  selectedYear!: number;
  selectedWeek: any = null;

  constructor(
    public dialogRef: MatDialogRef<SelectWeekDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.weekDefs = data.weekDefs || [];
    this.currentWeekNo = Number(data.currentWeekNo);
    this.currentYear = Number(data.currentYear);
  }

  ngOnInit(): void {
    // Extract unique financial years from weekDefs, starting from the last financial year (one year before current active roster year)
    const startYear = Math.min(moment().year(), this.currentYear || moment().year()) - 1;
    const yearSet = new Set<number>();
    this.weekDefs.forEach(w => {
      const yr = Number(w.year);
      if (yr && yr >= startYear) {
        yearSet.add(yr);
      }
    });
    // Ensure the start year is at least present
    yearSet.add(startYear);

    const sortedYears = Array.from(yearSet).sort((a, b) => a - b);
    const mappedYears = sortedYears.map(y => {
      const firstWeek = this.weekDefs.find(w => Number(w.year) === y);
      return {
        year: y,
        display_year: firstWeek?.display_year || y.toString()
      };
    });

    // Display only years that have a full financial year format (contains a hyphen)
    this.years = mappedYears.filter(y => y.display_year && y.display_year.includes('-'));

    // Fallback if list is empty
    if (this.years.length === 0) {
      this.years = mappedYears;
    }

    // Find currently active week definition to default the dropdowns
    const activeDef = this.weekDefs.find(
      w => Number(w.week_no) === this.currentWeekNo && Number(w.year) === this.currentYear
    );

    if (activeDef) {
      this.selectedYear = Number(activeDef.year);
      this.selectedWeek = activeDef;
    } else {
      this.selectedYear = this.currentYear || moment().year();
      const weeks = this.filteredWeeks;
      this.selectedWeek = weeks.length > 0 ? weeks[0] : null;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollToSelected();
    }, 150);
  }

  scrollToSelected() {
    const selectedEl = document.getElementById('selected-week-row');
    if (selectedEl) {
      selectedEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  onYearChange() {
    const activeDef = this.weekDefs.find(
      w => Number(w.year) === this.selectedYear && Number(w.week_no) === this.currentWeekNo
    );
    if (activeDef) {
      this.selectedWeek = activeDef;
    } else {
      const weeks = this.filteredWeeks;
      this.selectedWeek = weeks.length > 0 ? weeks[0] : null;
    }
    setTimeout(() => {
      this.scrollToSelected();
    }, 50);
  }

  getSelectedYearDisplay(): string {
    const yObj = this.years.find(y => y.year === this.selectedYear);
    return yObj ? yObj.display_year : this.selectedYear?.toString() || '';
  }

  get filteredWeeks() {
    const filtered = this.weekDefs.filter(w => Number(w.year) === this.selectedYear);
    return filtered.sort((a, b) => moment(a.start_date).diff(moment(b.start_date)));
  }

  isCurrentWeek(week: any): boolean {
    return Number(week.week_no) === this.currentWeekNo && Number(week.year) === this.currentYear;
  }

  selectWeek(week: any) {
    this.selectedWeek = week;
  }

  formatWeekRange(week: any): string {
    const start = moment(week.start_date);
    const end = moment(week.end_date);
    return `${start.format('DD MMM')} - ${end.format('DD MMM YYYY')}`;
  }

  formatDate(dateStr: string, formatStr: string = 'ddd, DD MMM YYYY'): string {
    return moment(dateStr).format(formatStr);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close(this.selectedWeek);
  }
}

